import { Text } from "@mantine/core";
import { useAppSelector } from "app/hooks";
import { selectInventoryItemLocations } from "features/admin/inventory/Inventory.slice";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { WriteLocationForm } from "../WriteLocationForm";

export const EditLocation = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const location = useAppSelector(selectInventoryItemLocations)
    .filter((location) => location.id === id)
    .at(0);

  if (!location) {
    return <Text>{t("NOT_FOUND")}</Text>;
  }

  return <WriteLocationForm location={location} />;
};
